import { ONLINE_PAYMENT_API_URL } from "../../ui/modules/notifications/constants/paymentDocumentConstants";

export const requestOnlinePaymentUrl = async (
  paymentPayload: Record<string, unknown>
): Promise<string> => {
  const response = await fetch(ONLINE_PAYMENT_API_URL, {
    method: "POST",
    body: JSON.stringify(paymentPayload),
  });

  if (!response.ok) {
    const responseBody = await response.text();
    throw new Error(
      `Payment request failed with status ${response.status}${
        responseBody ? `: ${responseBody.trim()}` : ""
      }`
    );
  }

  return (await response.text()).trim();
};
